
import React, { JSX, useEffect } from 'react'
import { useParams } from 'react-router'
import { OverlayShell } from 'components/OverlayShell'
import {
  OverlayLinkTarget,
  useOverlaySocketCredentialState
} from 'hooks/useOverlaySocketCredential'
import { ChatOverlayBody } from 'pages/overlay/ChatOverlayPage'
import { EmoteWallOverlayBody } from 'pages/overlay/EmoteWallOverlayPage'
import { MerchOverlayBody } from 'pages/overlay/MerchOverlayPage'
import { TickerBarOverlayBody } from 'components/TickerBarView'

const CHAT_DEFAULT_FIT = 2

const trimLinkKey = (raw: string | undefined): string =>
  (raw ?? '').replace(/[^0-9A-Za-z]+$/, '')

const useRobotsNoindex = (): void => {
  useEffect(() => {
    const meta = document.createElement('meta')
    meta.name = 'robots'
    meta.content = 'noindex, nofollow'
    document.head.appendChild(meta)
    return () => {
      meta.remove()
    }
  }, [])
}

const renderTarget = (target: OverlayLinkTarget, token: string): JSX.Element => {
  switch (target.kind) {
    case 'chat':
      return <ChatOverlayBody chatId={target.id} token={token} defaultFit={CHAT_DEFAULT_FIT} />
    case 'emotes':
      return <EmoteWallOverlayBody emoteWallId={target.id} token={token} />
    case 'merch':
      return <MerchOverlayBody merchOverlayId={target.id} token={token} />
    case 'tickerbar':
      return <TickerBarOverlayBody tickerBarId={target.id} token={token} />
  }
}

export const KeyOverlayPage = (): JSX.Element => {
  const { k: rawK } = useParams<{ k: string }>()
  const k = trimLinkKey(rawK)
  useRobotsNoindex()
  const { token, target } = useOverlaySocketCredentialState({ k, requireTarget: true })

  return (
    <OverlayShell>
      {token !== null && token !== '' && target !== null
        ? renderTarget(target, token)
        : null}
    </OverlayShell>
  )
}
